import ratingStars from "@/locales/default/en/ratingStars";
import billing from "@/locales/default/en/billing";
import reviewsSurvey from "@/locales/default/en/reviewsSurvey";
import reviews from "@/locales/default/en/reviews";
import address from "@/locales/default/en/address";
import errors from "@/locales/default/en/errors";
import discountFlag from "@/locales/default/en/discount-flag";
import guarantee_v2 from "@/locales/default/en/guarantee_v2";
import footer_landing from "@/locales/default/en/footer_landing";
import cardComponent from "@/locales/default/en/card-component";
import discountGift from "@/locales/default/en/discount-gift";
import processing from "@/locales/default/en/processing";
import superDiscountGift from '@/locales/default/en/discount-gift-super';
import planFinalTwo from '@/locales/default/en/plan-final-two';
import sexologyCourses from '@/locales/default/en/sexology_courses';
import verifyAccount from '@/locales/default/en/verifyAccount'
import whatsapp from '@/locales/default/en/whatsapp';
import comfortable_amount from '@/locales/default/en/comfortable-amount';
import checkout_v2 from "@/locales/default/en/checkout_v2";
import checkout_v3 from "@/locales/default/en/checkout_v3";
import checkout_v4 from "@/locales/default/en/checkout_v4";
import emailPage_v3 from "@/locales/default/en/email-page_v3";
import emailPage_v4 from '@/locales/default/en/email-page_v4';
import checkoutModal from "@/locales/default/en/checkout-modal";
export default {
  en: {
    errors,
    emailPage_v3,
    emailPage_v4,
    checkout_v2,
    checkout_v3,
    checkout_v4,
    checkoutModal,
    address,
    reviews,
    ratingStars,
    reviewsSurvey,
    footer_landing,
    cardComponent,
    discountFlag,
    guarantee_v2,
    discountGift,
    superDiscountGift,
    processing,
    planFinalTwo,
    sexologyCourses,
    whatsapp,
    billing,
    comfortable_amount,
    verifyAccount
  }
}

